import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import APP_CONFIG from '../../../config';
import { FileContext } from '../../../context/FileContext';
import { getItemDetails } from '../../../services/boards';
import CustomTipseen from '../../CustomTipseen/CustomTipseen';
import { EditorContainer } from '../Header.styled';
import AssignEmailControllers from './AssignEmailControllers';
import CheckboxControllers from './CheckboxControllers';
import DropdownControllers from './DropdownControllers';
import LineItemsControllers from './LineItemsControllers';
import PaymentController from './PaymentController';
import SignDateControllers from './SignDateControllers';
import SigningOrderControllers from './SigningOrderControllers';
import TextControllers from './TextControllers';
import TextBoxControllers from './TextboxControllers';
import DatePickerController from './DatePickerController';
import PageScaleControllers from './ZoomControllers';
import { isFeatureAvailable, FEATURES } from '@/constants/featureBasedPricing';

const ControlToolbarContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
  min-height: 56px !important;
  background-color: #f5f6f8;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
`;

const ControlToolbar = ({ isPreview, isGeneratePDFPage = false, isV3= false }) => {
  const { t } = useTranslation();

  const {
    addedFormFields,
    currentSelectedItem,
    updateFormFields,
    fileId,
    itemId,
    setShowSignateOrderModal,
    pricingPlan,
    slug,
    signersSettings,
  } = useContext(FileContext);

  const { data: queryData } = useQuery(
    ['get-columns', itemId, fileId],
    () => getItemDetails(fileId, itemId),
    {
      enabled: !!itemId && !!fileId,
    },
  );

  const selectedItem = addedFormFields[currentSelectedItem.current];

  // TODO@Rohit: remove the first four fields as this is only for handling backwards compatibility.
  const SIGNATURE_FIELDS = [
    'receiver-initials',
    'sender-initials',
    'receiver-signature',
    'sender-signature',
    APP_CONFIG.form_fields.initialsField.id,
    APP_CONFIG.form_fields.signatureField.id,
  ];

  const isSigningOrderAllowedInCurrentPlan = isFeatureAvailable(pricingPlan, FEATURES.SIGNING_ORDER);

  return (
    <>
      <ControlToolbarContainer>
        <PageScaleControllers />
        {!isPreview ? (
          <EditorContainer>
            {currentSelectedItem.current !== null ? (
              <>
                {selectedItem?.itemId === 'checkbox' ? (
                  <CheckboxControllers
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                  />
                ) : selectedItem?.itemId === 'text-box' ? (
                  <TextBoxControllers
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                    queryData={queryData}
                  />
                ) : selectedItem?.itemId === 'sd-dropdown' ? (
                  <DropdownControllers
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                    queryData={queryData}
                  />
                ) : selectedItem?.itemId === 'line-item' ? (
                  <LineItemsControllers t={t} />
                ) : selectedItem?.itemId === 'sd-payment' ? (
                  <PaymentController
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                    queryData={queryData}
                    isV3={isV3}
                  />
                ) : selectedItem?.itemId === 'sign-date' ? (
                  <SignDateControllers
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                  />
                ) : selectedItem?.itemId ===
                  APP_CONFIG.form_fields.standard_fields.datePicker.id ? (
                  <DatePickerController
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                    queryData={queryData}
                  />
                ) : SIGNATURE_FIELDS.includes(selectedItem?.itemId) ? (
                  <AssignEmailControllers
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                  />
                ) : (
                  <TextControllers
                    t={t}
                    selectedItem={selectedItem}
                    addedFormFields={addedFormFields}
                    updateFormFields={updateFormFields}
                  />
                )}
              </>
            ) : null}

            {!isGeneratePDFPage &&
            selectedItem &&
            [...APP_CONFIG.signature_field_types].includes(
              selectedItem.title,
            ) ? (
              (!isSigningOrderAllowedInCurrentPlan && !signersSettings?.isSigningOrderRequired) ? (
                <CustomTipseen
                  content="This feature isn't available with your current plan. Please upgrade to use this and other exciting features."
                  submitButtonText="Upgrade"
                  theme="primary"
                  submitButtonColor="#FFD383"
                  submitButtonTextColor="#000"
                  handleSubmit={() =>
                    window.open(
                      `https://${slug}.monday.com/apps/installed_apps/10050849`,
                    )
                  }
                >
                  <SigningOrderControllers
                    disabled
                    setShowSignateOrderModal={() => {}}
                    t={t}
                  />
                </CustomTipseen>
              ) : (
                !isV3 ? (
                  <SigningOrderControllers
                    setShowSignateOrderModal={setShowSignateOrderModal}
                    t={t}
                  />
                ) : null
              )
            ) : null}
          </EditorContainer>
        ) : null}
      </ControlToolbarContainer>
    </>
  );
};
export default ControlToolbar;
